import PropTypes from 'prop-types';

var propTypes = {
    active: PropTypes.string.isRequired,
    clustered: PropTypes.bool,
    borderless: PropTypes.bool,
    onSelect: PropTypes.func.isRequired,
    className: PropTypes.string,
    vertical: PropTypes.bool,
};
var tabPropTypes = {
    name: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    isActive: PropTypes.bool,
    onClick: PropTypes.func,
    className: PropTypes.string,
    testId: PropTypes.string,
};
var defaultProps = {
    clustered: false,
    borderless: false,
    vertical: false,
};
var tabDefaultProps = {
    disabled: false,
};

export { defaultProps, propTypes, tabDefaultProps, tabPropTypes };
